import { Box, SxProps } from '@mui/material';
import * as React from 'react';
import { FunctionComponent, useMemo } from 'react';
import PreFilteredResourcesList from '../common/resourceLibrary/PreFilteredResourcesList';

const LayoutStyles: SxProps = {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '1.5rem',
    paddingBottom: '1.5rem',
    flexDirection: 'column',
    overflowY: 'hidden',
    width: '100%',
    alignItems: 'flex-start',
    margin: 'auto',
};

interface TechnicalResourcesProps {
    isAutomotive?: boolean;
    backgroundColor?: string;
}

const TechnicalResources: FunctionComponent<TechnicalResourcesProps> = ({
    isAutomotive,
    backgroundColor,
}) => {
    const [view, setView] = React.useState('module');
    const MemoizedResourcesList = useMemo(
        () => (
            <PreFilteredResourcesList
                backgroundColor={backgroundColor ?? '#F2F2F2'}
                isTechnicalResources={isAutomotive}
            />
        ),
        [view]
    );

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: backgroundColor ?? '#F2F2F2',
                }}
            >
                <Box sx={LayoutStyles}>{MemoizedResourcesList}</Box>
            </Box>
        </>
    );
};

export default TechnicalResources;
